/**
 * Módulo principal para la generación de JSONs de Comprobantes Fiscales Electrónicos (e-CF)
 * Este módulo integra todas las funciones necesarias para procesar los datos del sistema
 * y generar JSONs específicos para cada tipo de comprobante fiscal electrónico
 */

import { generateECFJson, generateAllECFJsons } from './generateECFJson';
import { processSystemData, exampleWithDirectData } from './ecfGenerator';
import processECFByType from './processECFByType';
import orderECFByXSD from './orderECFByXSD';
import correctECFStructure from './correctECFStructure';

/**
 * Procesa los datos del sistema y genera un JSON de e-CF
 * @param {Object} data - Datos del sistema
 * @param {boolean} generateAllTypes - Indica si se deben generar JSONs para todos los tipos de comprobantes
 * @returns {Object} - JSON o JSONs generados según el tipo de comprobante
 */
function processECF(data, generateAllTypes = false) {
  try {
    // Verificar si los datos son válidos
    if (!data || typeof data !== 'object') {
      throw new Error('Los datos proporcionados no son válidos');
    }
    
    // Configurar la generación de todos los tipos si se solicita
    if (generateAllTypes) {
      data.generate_all_types = true;
    }
    
    // Procesar los datos y generar los JSONs
    const processedData = processSystemData(data);
    
    // Corregir la estructura según el esquema XSD oficial
    const correctedData = correctECFStructure(processedData);
    
    // Ordenar los campos según el esquema XSD correspondiente
    return orderECFByXSD(correctedData);
  } catch (error) {
    console.error('Error al procesar los datos para e-CF:', error);
    return null;
  }
}

// Exportar todas las funciones necesarias
export {
  processECF,
  generateECFJson,
  generateAllECFJsons,
  processSystemData,
  exampleWithDirectData,
  processECFByType,
  orderECFByXSD
};

// Exportar processECF como función principal por defecto
export default processECF;